var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1869_9166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26243 16.3787C3.45279 16.9216 2.3335 17.6716 2.3335 18.5C2.3335 20.1569 6.81065 21.5 12.3335 21.5C17.8563 21.5 22.3335 20.1569 22.3335 18.5C22.3335 17.6716 21.2142 16.9216 19.4045 16.3787",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 17.5C12.3335 17.5 18.8335 13.252 18.8335 8.3409C18.8335 4.83892 15.9233 2 12.3335 2C8.74365 2 5.8335 4.83892 5.8335 8.3409C5.8335 13.252 12.3335 17.5 12.3335 17.5Z",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 11C13.7142 11 14.8335 9.8807 14.8335 8.5C14.8335 7.1193 13.7142 6 12.3335 6C10.9528 6 9.8335 7.1193 9.8335 8.5C9.8335 9.8807 10.9528 11 12.3335 11Z",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1869_9166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6d05b1c4f23d424a80b652060270b35d.svg";
export { ForwardRef as ReactComponent };